<article>
  <div>
    Prescription
    @if (codeActiviteService.FORFAITS_ASSOCIES_PPC.includes(activite)) {
      @if (prescription.format == "DEP") {
        O2
      } @else {
        PPC
      }
    }
    du {{ prescription.dateDebut | date: "dd/MM/yyyy" }}
  </div>
  @if (prescription.prescriptionForm) {
    @if (prescription.dateRetour) {
      <tui-chip appearance="positive" iconStart="@tui.check">
        Transmise
      </tui-chip>
    } @else {
      @if (prescription.prescriptionForm!.aSigner) {
        <tui-chip appearance="warning" iconStart="@tui.signature">
          En cours de signature
        </tui-chip>
      } @else {
        <tui-chip appearance="positive" iconStart="@tui.hourglass">
          En cours de transmission
        </tui-chip>
      }
    }
    @if (prescription.prescriptionForm) {
      <button
        type="button"
        appearance="outline"
        iconStart="@tui.download"
        size="s"
        tuiButton
        (click)="openPdf(actions, prescription.prescriptionForm!)"
      >
        Télécharger
      </button>
      @if (
        !prescription.dateRetour &&
        (prescription.prescriptionForm!.user?.role?.slug == "super-admin" ||
          prescription.prescriptionForm!.user?.role?.slug == "admin")
      ) {
        @if (codeActiviteService.PPC.includes(activite)) {
          <button
            type="button"
            [disabled]="userList!.length == 0"
            iconStart="@tui.pencil"
            appearance="outline"
            size="s"
            (click)="openForm(prescription, 'PPC', true)"
            tuiButton
          >
            Rééditer
          </button>
        } @else if (codeActiviteService.VENTILATION.includes(activite)) {
          <button
            type="button"
            [disabled]="userList!.length == 0"
            iconStart="@tui.pencil"
            appearance="outline"
            size="s"
            (click)="openForm(prescription, 'VENTILATION', true)"
            tuiButton
          >
            Rééditer
          </button>
        } @else if (codeActiviteService.O2.includes(activite)) {
          <button
            type="button"
            [disabled]="userList!.length == 0"
            iconStart="@tui.pencil"
            appearance="outline"
            size="s"
            (click)="openForm(prescription, 'O2', true)"
            tuiButton
          >
            Rééditer
          </button>
        } @else if (
          codeActiviteService.FORFAITS_ASSOCIES_PPC.includes(activite)
        ) {
          @if (prescription.format == "DEP") {
            <button
              type="button"
              [disabled]="userList!.length == 0"
              iconStart="@tui.pencil"
              appearance="outline"
              size="s"
              (click)="openForm(prescription, 'O2', true)"
              tuiButton
            >
              Rééditer
            </button>
          } @else {
            <button
              type="button"
              [disabled]="userList!.length == 0"
              iconStart="@tui.pencil"
              appearance="outline"
              size="s"
              (click)="openForm(prescription, 'PPC', true)"
              tuiButton
            >
              Rééditer
            </button>
          }
        } @else if (
          codeActiviteService.FORFAITS_ASSOCIES_VNI.includes(activite)
        ) {
          <button
            type="button"
            [disabled]="userList!.length == 0"
            iconStart="@tui.pencil"
            appearance="outline"
            size="s"
            (click)="openForm(prescription, 'O2VNI', true)"
            tuiButton
          >
            Rééditer
          </button>
        } @else if (codeActiviteService.AVF.includes(activite)) {
          <button
            type="button"
            [disabled]="userList!.length == 0"
            iconStart="@tui.pencil"
            appearance="outline"
            size="s"
            (click)="openForm(prescription, 'AVF', true)"
            tuiButton
          >
            Rééditer
          </button>
        } @else if (codeActiviteService.AEROSOLS.includes(activite)) {
          <button
            type="button"
            [disabled]="userList!.length == 0"
            iconStart="@tui.pencil"
            appearance="outline"
            size="s"
            (click)="openForm(prescription, 'AEROSOLS', true)"
            tuiButton
          >
            Rééditer
          </button>
        }
      }

      @if (
        authService.user?.role?.slug == "super-admin" ||
        authService.user?.role?.slug == "admin"
      ) {
        <button
          type="button"
          appearance="accent"
          iconStart="@tui.trash-2"
          size="s"
          tuiButton
          (click)="onDelete(prescription.prescriptionForm!)"
        >
          Supprimer
        </button>
      }
    }
  } @else {
    @if (codeActiviteService.PPC.includes(activite)) {
      <button
        type="button"
        [disabled]="userList!.length == 0"
        iconStart="@tui.pencil"
        size="s"
        (click)="openForm(prescription, 'PPC')"
        tuiButton
      >
        Editer
      </button>
    } @else if (codeActiviteService.VENTILATION.includes(activite)) {
      <button
        type="button"
        [disabled]="userList!.length == 0"
        iconStart="@tui.pencil"
        size="s"
        (click)="openForm(prescription, 'VENTILATION')"
        tuiButton
      >
        Editer
      </button>
    } @else if (codeActiviteService.O2.includes(activite)) {
      <button
        type="button"
        [disabled]="userList!.length == 0"
        iconStart="@tui.pencil"
        size="s"
        (click)="openForm(prescription, 'O2')"
        tuiButton
      >
        Editer
      </button>
    } @else if (codeActiviteService.FORFAITS_ASSOCIES_PPC.includes(activite)) {
      @if (prescription.format == "DEP") {
        <button
          type="button"
          [disabled]="userList!.length == 0"
          iconStart="@tui.pencil"
          size="s"
          (click)="openForm(prescription, 'O2')"
          tuiButton
        >
          Editer
        </button>
      } @else {
        <button
          type="button"
          [disabled]="userList!.length == 0"
          iconStart="@tui.pencil"
          size="s"
          (click)="openForm(prescription, 'PPC')"
          tuiButton
        >
          Editer
        </button>
      }
    } @else if (codeActiviteService.FORFAITS_ASSOCIES_VNI.includes(activite)) {
      <button
        type="button"
        [disabled]="userList!.length == 0"
        iconStart="@tui.pencil"
        size="s"
        (click)="openForm(prescription, 'O2VNI')"
        tuiButton
      >
        Editer
      </button>
    } @else if (codeActiviteService.AVF.includes(activite)) {
      <button
        type="button"
        [disabled]="userList!.length == 0"
        iconStart="@tui.pencil"
        size="s"
        (click)="openForm(prescription, 'AVF')"
        tuiButton
      >
        Editer
      </button>
    } @else if (codeActiviteService.AEROSOLS.includes(activite)) {
      <button
        type="button"
        [disabled]="userList!.length == 0"
        iconStart="@tui.pencil"
        size="s"
        (click)="openForm(prescription, 'AEROSOLS')"
        tuiButton
      >
        Editer
      </button>
    }
  }
</article>

<ng-template #actions let-content="content">
  <a download size="s" tuiButton [href]="content"> Télécharger </a>
</ng-template>
